import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
} from '@ionic/angular';
import { AddReviewsPage } from '../add-reviews/add-reviews.page';
import { GlobalVariable } from '../global';
import { PhotoViewerPage } from '../photo-viewer/photo-viewer.page';
import { ServerService } from '../providers/server.service';
import { ShowUserReviewsPage } from '../show-user-reviews/show-user-reviews.page';
import { UserReviewsPage } from '../user-reviews/user-reviews.page';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.page.html',
  styleUrls: ['./reviews.page.scss'],
})
export class ReviewsPage implements OnInit {
  name: any;
  length: any;
  placeName: any;
  data: any;
  details: any;
  reviewData: any;
  reviewId: any;
  username: any;
  averageRating: any;
  // userReviews = [
  //     {
  //       name: "Micheal",
  //       rating: 4,
  //       time: "30 mins ago",
  //       itemOrderd: [
  //         {name:'Cheese Pizza large'},
  //         {name:'French fries'},
  //       ],
  //       msg: " The food was really good and we enjoyed a lot.service was good",
  //     },
  //     {
  //       name: "Rafeal",
  //       rating: 3,
  //       time: "Aug 12,2021",
  //       itemOrderd: [
  //         {name:'Burger'},
  //         {name:'French fries'},
  //       ],
  //       msg: " enjoyed alot. service was good",
  //     },
  //     {
  //       name: "Natasha",
  //       rating: 1,
  //       time: "3 days ago",
  //       itemOrderd: [
  //         {name:'Biryani'},
  //         {name:'Cold drink'},
  //       ],
  //       msg: "Food was cold and i got that for my family and my team",
  //     },
  //   ];
  Randomcolor: string;
  businessData: any;
  info: any;
  dataNotLoaded: boolean = true;
  isComingFromThankPage: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public server: ServerService,
    private photoViewer: PhotoViewer,
    public platform: Platform,
    public globals: GlobalVariable,
    public modalCtrl: ModalController,

    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController
  ) {
    // this.reviewId = this.navParams.get('reviewData');
    this.businessData = this.globals.activeBusinessData;
    this.reviewId = this.businessData.business_id;
    this.placeName = this.globals.activeBusinessData.username;
    this.globals.Email = localStorage.getItem('userEmail');
    this.getColors();
    this.reviewdata();
    this.route.queryParams.subscribe((_p) => {
      this.reviewId =
        this.router.getCurrentNavigation().extras.state.reviewData;
      this.isComingFromThankPage =
        this.router.getCurrentNavigation().extras.state.thankYouPage;
      console.log('review businness id', this.reviewId);
    });
  }

  ngOnInit() {}
  reviewdata() {
    let response = this.server.BusinessInformation(
      this.reviewId,
      this.placeName,
      this.globals.udid
    );
    console.log(this.reviewId, this.placeName);
    // let loading = this.loadingCtrl.create({
    //     content: "Loading...",
    // });
    // loading.present();

    response.subscribe(
      (data) => {
        this.dataNotLoaded = false;
        this.data = data;
        console.log('reviews data', data);
        this.info = data.info;
        // loading.dismiss();
        this.averageRating = this.data.average_rating;
        this.details = this.data;
        this.name = this.details.info.name;
        this.reviewData = this.details.reviews;
        this.length = this.reviewData.length;
      },
      (error) => {
        // loading.dismiss();
        this.globals.presentToast('Network error');
      }
    );
  }

  dismiss() {
    if (this.isComingFromThankPage) {
      this.navCtrl.navigateRoot('home');
    } else {
      this.navCtrl.pop();
    }
    // this.navCtrl.push('BusinessListingMainPage');
  }
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = '#';
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    this.Randomcolor = color;
    console.log(this.Randomcolor);
  }
  async editReview(reviewdata) {
    console.log(reviewdata);
    let isLogin = localStorage.getItem('isLogin');
    if (isLogin == 'true') {
      let modal = await this.modalCtrl.create({
        component: AddReviewsPage,
        componentProps: {
          place: this.placeName,
          bID: this.reviewId,
          reviewData: reviewdata,
          editReviews: 'true',
        },
        cssClass:'add_review_modal',
      });
      modal.onDidDismiss().then((data) => {
        this.navCtrl.pop();
        // this.navCtrl.push('BusinessListingMainPage');
        // this.navCtrl.pop();
      });
      modal.present();
    } else {
      let alert = await this.alertCtrl.create({
        message: 'Login to use this feature',
        buttons: ['Ok'],
      });
      alert.present();
    }
  }
  async addReview() {
    let isLogin = localStorage.getItem('isLogin');
    if (isLogin == 'true') {
      let modal = await this.modalCtrl.create({
        component: AddReviewsPage,
        componentProps: {
          place: this.placeName,
          bID: this.reviewId,
          reviewData: undefined,
        },
        cssClass:'add_review_modal',
      });
      modal.onDidDismiss().then((data) => {
        this.navCtrl.pop();
        // this.navCtrl.push('BusinessListingMainPage');
        // this.navCtrl.pop();
      });
      modal.present();
    } else {
      let alert = await this.alertCtrl.create({
        message: 'Login to use this feature',
        buttons: ['Ok'],
      });
      alert.present();
    }
  }
  async openUsersReviews(user) {
    let modal = await this.modalCtrl.create({
      component: ShowUserReviewsPage,
      componentProps: { data: { user: user } },
    });
    modal.onDidDismiss().then((data) => {
      console.log(data);
      if (data != null || data != undefined) {
      }
      console.log('usermodal says.=> ', data);
    });
    modal.present();
  }

  async openImage(image) {
    let modal = await this.modalCtrl.create({
      component: PhotoViewerPage,
      componentProps: { image: image },
    });
    modal.present();
    // var options = {
    //     share: true, // default is false
    //     closeButton: true, // iOS only: default is true
    //     copyToReference: true // iOS only: default is false
    //   };

    //   if (this.platform.is("ios")) {
    //     image = decodeURIComponent(image);
    //   }

    //   this.photoViewer.show(image, "Review image", options);

    //   this.photoViewer.show(image);
  }
}
